import { useState, useMemo } from 'react';
import { useData } from '../context/DataContext';
import './Products.css';

export default function Products() {
  const { data, loading } = useData();
  const products = data?.products || [];
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  const categories = useMemo(() => {
    const cats = [...new Set(products.map(p => p.category))];
    return ['all', ...cats];
  }, [products]);

  const filtered = useMemo(() => {
    return products.filter(p => {
      const matchCategory = filter === 'all' || p.category === filter;
      const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) ||
        p.description.toLowerCase().includes(search.toLowerCase()) ||
        p.tags.some(t => t.toLowerCase().includes(search.toLowerCase()));
      return matchCategory && matchSearch;
    });
  }, [products, filter, search]);

  const handleVisit = (url) => {
    if (!url || !String(url).trim()) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <main className="page products-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">IWX Ecosystem</span>
          <h1 className="section-title__heading">Our Products</h1>
          <p className="section-title__description">
            Discover the IWX suite of products. Each platform runs independently — click to explore and get started.
          </p>
        </div>

        <div className="products-page__toolbar">
          <input
            type="text"
            className="products-page__search"
            placeholder="Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            aria-label="Search products"
          />
          <div className="products-page__filters">
            {categories.map(cat => (
              <button
                key={cat}
                className={`products-page__filter ${filter === cat ? 'products-page__filter--active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat === 'all' ? 'All' : cat}
              </button>
            ))}
          </div>
        </div>

        <div className="products-page__grid">
          {filtered.map(project => (
            <div key={project.id} className="project-card" onClick={() => handleVisit(project.url)}>
              <div className="project-card__header">
                <div className="project-card__icon" style={{ backgroundColor: `${project.color}18`, color: project.color }}>
                  <span>{project.icon}</span>
                </div>
                <span className={`project-card__status project-card__status--${project.status}`}>
                  {project.status === 'live' ? '● Live' : project.status === 'development' ? '● Dev' : '○ Planned'}
                </span>
              </div>
              <h3 className="project-card__name">{project.name}</h3>
              <p className="project-card__tagline">{project.tagline}</p>
              <p className="project-card__description">{project.description}</p>
              <div className="project-card__footer">
                <div className="project-card__tags">
                  {project.tags.slice(0, 3).map(tag => (
                    <span key={tag} className="project-card__tag">{tag}</span>
                  ))}
                </div>
                <div className="project-card__footer-right">
                  <span className="project-card__category">{project.category}</span>
                  <span className="project-card__arrow">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="7" y1="17" x2="17" y2="7" />
                      <polyline points="7 7 17 7 17 17" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="products-page__empty">
            <p>No products found matching your criteria.</p>
          </div>
        )}
      </div>
    </main>
  );
}
